import { FDCApprovalGroups } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const groups = CreateViewEditSoftRemoveRestore({
  page: FDCApprovalGroups,
  object: 'Approval Group',
  view: 'AFADA74D-6CB8-4D1C-92BD-6C7FF85A54A9',
  create: 'E49E40F7-6FFF-421C-8071-991C711A789D',
  edit: '11075B20-60E7-4B24-94C9-4F67058959B6',
  removeRestore: '1E6EB0DB-2A5E-4F7D-85D9-ABE3AF6BF1AB',
})

export const ViewFDCApprovalGroup = groups.View
export const CreateFDCApprovalGroup = groups.Create
export const EditFDCApprovalGroup = groups.Edit
export const RemoveRestoreFDCApprovalGroup = groups.RemoveRestore

export type FDCApprovalGroupPermission =
  | typeof ViewFDCApprovalGroup
  | typeof CreateFDCApprovalGroup
  | typeof EditFDCApprovalGroup
  | typeof RemoveRestoreFDCApprovalGroup
